import base from './thunks/base';

export { base };
